export default "__VITE_ASSET__BFEqGebI__"